<template>
  <tr>
    <td class="text-center align-middle">
      <i class="material-icons dnd-icon">dehaze</i>
    </td>
    <td class="align-middle">
      {{ itemData.name }}
      <small
        v-if="itemData.reference_type === 'AIRPORT' && itemData.handler_type"
        class="d-block">
        <strong>Handler type:</strong> {{ itemData.handler_type }}
      </small>
    </td>
    <td class="align-middle" style="width: 140px;">
      <d-button
        theme="primary"
        @click.native="editItem"
        class="mr-2"
        title="Edit">
        <i class="material-icons">edit</i>
      </d-button>
      <d-button
        theme="danger"
        :disabled="removeInProgress"
        @click.prevent="removeItem"
        title="Delete">
        <i class="material-icons">delete</i>
      </d-button>
    </td>
  </tr>
</template>

<script>
import ListUtils from './../../utils/ListUtils.js';

export default {
  name: 'checklist-list-item',
  props: {
    itemData: {
      type: Object,
      default: () => ({}),
      required: true
    }
  },
  data () {
    return {
      removeInProgress: false
    };
  },
  methods: {
    removeItem () {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/check-lists/delete/',
        id: parseInt(this.itemData.id, 10),
        successTitle: 'Item removed',
        successText: 'The selected item has been removed',
        confirmTitle: 'Do you really want to remove this item?',
        confirmText: 'This operation cannot be reverted',
        errorTitle: 'An error occurred',
        errorText: 'Please try again.',
        successAction: () => {
          this.removeInProgress = false;
          this.$bus.$emit('checklist-list-reload');
        },
        cancelAction: () => {
          this.removeInProgress = false;
        },
        errorAction: () => {
          this.removeInProgress = false;
        }
      });
    },
    editItem () {
      this.$bus.$emit('show-checklist-item-popup', 'edit', false, false, this.itemData.id);
    }
  }
};
</script>

<style lang="scss">
.dnd-icon {
  color: #999;
  cursor: move;
  font-size: 24px!important;
  position: relative;
  top: 4px!important;
}
</style>
